(function () {
  if (window.SDJBAttribution) return;
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
    'gclid', 'gbraid', 'wbraid', 'msclkid', 'fbclid', 'gad_campaignid', 'oppref'];
  var TTL = 90 * 24 * 60 * 60 * 1000;
  var FIRST = 'sdjb_shop_first_touch_v2', LATEST = 'sdjb_shop_latest_campaign_v2';
  var first = null, latest = null, lastLocation = '';

  function value(key, input) {
    if (typeof input !== 'string') return '';
    if (key === 'oppref') return input.length > 0 && input.length <= 4096 && !/[\s\u0000-\u001f\u007f]/.test(input) ? input : '';
    return input.trim().replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 500);
  }

  function campaign(input) {
    var output = {};
    if (!input || typeof input !== 'object' || Array.isArray(input)) return output;
    KEYS.forEach(function (key) {
      var entry = value(key, input[key]);
      if (entry) output[key] = entry;
    });
    return output;
  }

  function safeUrl(input) {
    try {
      var parsed = new URL(input);
      return /^https?:$/.test(parsed.protocol) ? (parsed.origin + parsed.pathname).slice(0, 1024) : '';
    } catch (error) { return ''; }
  }

  function valid(input, now) {
    if (!input || typeof input.t !== 'number' || !Number.isFinite(input.t) || input.t > now + 300000 || now - input.t >= TTL) return null;
    return { t: input.t, d: campaign(input.d), l: safeUrl(input.l), r: safeUrl(input.r) };
  }

  function read(key, now) {
    var candidates = [];
    try { candidates.push(JSON.parse(localStorage.getItem(key))); } catch (error) {}
    try {
      var pair = document.cookie.split(';').map(function (entry) { return entry.trim(); })
        .find(function (entry) { return entry.indexOf(key + '=') === 0; });
      if (pair) candidates.push(JSON.parse(decodeURIComponent(pair.slice(key.length + 1))));
    } catch (error) {}
    return candidates.map(function (entry) { return valid(entry, now); }).filter(Boolean)
      .sort(function (a, b) { return key === FIRST ? a.t - b.t : b.t - a.t; })[0] || null;
  }

  function persist(key, record) {
    var serialized = JSON.stringify(record);
    try { localStorage.setItem(key, serialized); } catch (error) {}
    try {
      var encoded = encodeURIComponent(serialized);
      if (encoded.length > 3700) encoded = encodeURIComponent(JSON.stringify({ t: record.t, d: {}, l: '', r: '' }));
      document.cookie = key + '=' + encoded + ';path=/;max-age=' +
        Math.max(0, Math.floor((record.t + TTL - Date.now()) / 1000)) + ';SameSite=Lax;Secure';
    } catch (error) {}
  }

  function capture() {
    var now = Date.now(), href = window.location.href;
    first = [valid(first, now), read(FIRST, now)].filter(Boolean).sort(function (a, b) { return a.t - b.t; })[0] || null;
    latest = [valid(latest, now), read(LATEST, now), read('sdjb_attr', now)].filter(Boolean)
      .sort(function (a, b) { return b.t - a.t; })[0] || null;
    var newArrival = lastLocation !== href;
    if (!newArrival && first) return;
    lastLocation = href;
    var current = {}, params = new URLSearchParams(window.location.search);
    KEYS.forEach(function (key) {
      if (key === 'oppref') {
        var pair = window.location.search.replace(/^\?/, '').split('&').find(function (entry) { return entry.indexOf('oppref=') === 0; });
        current[key] = value(key, pair ? pair.slice(7) : '');
      } else current[key] = value(key, params.get(key));
    });
    current = campaign(current);
    var arrival = { t: now, d: current, l: safeUrl(href), r: safeUrl(document.referrer) };
    if (!first) { first = arrival; persist(FIRST, first); }
    if (newArrival && Object.keys(current).length) { latest = arrival; persist(LATEST, latest); }
  }

  function get() {
    capture();
    var output = {};
    KEYS.forEach(function (key) {
      if (first && first.d[key]) output['first_' + key] = first.d[key];
      if (latest && latest.d[key]) { output[key] = latest.d[key]; output['0' + key] = latest.d[key]; }
    });
    if (first) {
      output.first_touch_at = new Date(first.t).toISOString();
      output.first_landing_page = first.l;
      output.first_referrer = first.r;
    }
    if (latest) {
      output.campaign_touch_at = new Date(latest.t).toISOString();
      output.campaign_landing_page = latest.l;
      output.campaign_referrer = latest.r;
      if (latest.r) output['0referrer'] = latest.r;
    }
    return output;
  }

  function nativeFields(form) {
    if (!form || !form.querySelector || !form.querySelector('[name="form_type"][value="contact"]')) return;
    var fields = get();
    form.querySelectorAll('[data-sdjb-attribution]').forEach(function (input) { input.remove(); });
    Object.keys(fields).forEach(function (key) {
      if (key.charAt(0) === '0') return;
      var name = 'contact[' + key + ']';
      var input = form.querySelector('[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input'); input.type = 'hidden'; input.name = name;
        input.setAttribute('data-sdjb-attribution', ''); form.appendChild(input);
      }
      input.value = fields[key];
    });
  }

  window.SDJBAttribution = { get: get, nativeFields: nativeFields };
  capture();
  document.addEventListener('submit', function (event) { nativeFields(event.target); }, true);
})();
